import { itemCategoriesApi } from "@/api/endpoints";
import { ReferenceNameMasterPage } from "./ReferenceNameMasterPage";

export function ItemCategoriesPage() {
  return (
    <ReferenceNameMasterPage
      title="Item Categories"
      noun="Category"
      api={itemCategoriesApi}
      queryKey="item-categories"
      permPrefix="catalog.category"
    />
  );
}
